export const experienceData = [
    {
        id: 1,
        company: 'Programming Hero',
        jobtitle: 'Intern',
        startYear: '2021',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Embedded System',
        jobtitle: 'Automated projects',
        startYear: '2020',
        endYear: '2021'
    },
    {
        id: 3,
        company: 'Non-Profit',
        jobtitle: 'General Member',
        startYear: '2021',
        endYear: '2020'
    },
]